var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/react/react": {
		getter: () => (__webpack_require__.e("vendors-node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/react/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	"webpack/sharing/consume/default/@fortawesome/fontawesome-svg-core/@fortawesome/fontawesome-svg-core": {
		getter: () => (__webpack_require__.e("vendors-node_modules_fortawesome_fontawesome-svg-core_index_mjs").then(() => (() => (__webpack_require__(/*! @fortawesome/fontawesome-svg-core */ "./node_modules/@fortawesome/fontawesome-svg-core/index.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.6.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@fortawesome/fontawesome-svg-core",
	},
	"webpack/sharing/consume/default/redux/redux": {
		getter: () => (__webpack_require__.e("vendors-node_modules_redux_dist_redux_mjs").then(() => (() => (__webpack_require__(/*! redux */ "./node_modules/redux/dist/redux.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "redux",
	},
	"webpack/sharing/consume/default/react-jhipster/react-jhipster": {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-jhipster_lib_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_dayjs_dayjs-webpack_sharing_consume_default_tslib_tslib"), __webpack_require__.e("webpack_sharing_consume_default_react-hook-form_react-hook-form-webpack_sharing_consume_defau-c3c16d"), __webpack_require__.e("_5580-_03fb-_6197-_b8cb-_c717")]).then(() => (() => (__webpack_require__(/*! react-jhipster */ "./node_modules/react-jhipster/lib/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.25.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-jhipster",
	},
	"webpack/sharing/consume/default/@reduxjs/toolkit/@reduxjs/toolkit": {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_modern_mjs"), __webpack_require__.e("webpack_sharing_consume_default_redux_redux")]).then(() => (() => (__webpack_require__(/*! @reduxjs/toolkit */ "./node_modules/@reduxjs/toolkit/dist/redux-toolkit.modern.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.3.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@reduxjs/toolkit",
	},
	"webpack/sharing/consume/default/axios/axios": {
		getter: () => (__webpack_require__.e("vendors-node_modules_axios_index_js").then(() => (() => (__webpack_require__(/*! axios */ "./node_modules/axios/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.7.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "axios",
	},
	"webpack/sharing/consume/default/react-redux/react-redux": {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-redux_dist_react-redux_mjs"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__(/*! react-redux */ "./node_modules/react-redux/dist/react-redux.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "9.1.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	"webpack/sharing/consume/default/app/shared/reducers/reducer.utils/app/shared/reducers/reducer.utils": {
		getter: () => (__webpack_require__.e("src_main_webapp_app_shared_reducers_reducer_utils_ts").then(() => (() => (__webpack_require__(/*! app/shared/reducers/reducer.utils */ "./src/main/webapp/app/shared/reducers/reducer.utils.ts"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "app/shared/reducers/reducer.utils",
	},
	"webpack/sharing/consume/default/react-toastify/react-toastify": {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_react-toastify_dist_react-toastify_esm_mjs"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(() => (() => (__webpack_require__(/*! react-toastify */ "./node_modules/react-toastify/dist/react-toastify.esm.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "10.0.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-toastify",
	},
	"webpack/sharing/consume/default/react-redux-loading-bar/react-redux-loading-bar": {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_react-redux-loading-bar_build_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react-redux_react-redux")]).then(() => (() => (__webpack_require__(/*! react-redux-loading-bar */ "./node_modules/react-redux-loading-bar/build/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.0.8",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-redux-loading-bar",
	},
	"webpack/sharing/consume/default/app/shared/reducers/app/shared/reducers": {
		getter: () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_dayjs_dayjs-webpack_sharing_consume_default_tslib_tslib"), __webpack_require__.e("webpack_sharing_consume_default_app_shared_reducers_locale_app_shared_reducers_locale"), __webpack_require__.e("src_main_webapp_app_modules_account_activate_activate_reducer_ts-src_main_webapp_app_modules_-ff1a72"), __webpack_require__.e("src_main_webapp_app_shared_reducers_index_ts")]).then(() => (() => (__webpack_require__(/*! app/shared/reducers */ "./src/main/webapp/app/shared/reducers/index.ts"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "app/shared/reducers",
	},
	"webpack/sharing/consume/default/react-router-dom/react-router-dom": {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_remix-run_router_dist_router_js"), __webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("webpack_sharing_consume_default_react-router_react-router")]).then(() => (() => (__webpack_require__(/*! react-router-dom */ "./node_modules/react-router-dom/dist/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.27.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	"webpack/sharing/consume/default/tslib/tslib": {
		getter: () => (__webpack_require__.e("vendors-node_modules_tslib_tslib_es6_mjs").then(() => (() => (__webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "tslib",
	},
	"webpack/sharing/consume/default/dayjs/dayjs": {
		getter: () => (__webpack_require__.e("node_modules_dayjs_dayjs_min_js").then(() => (() => (__webpack_require__(/*! dayjs */ "./node_modules/dayjs/dayjs.min.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "1.11.13",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "dayjs",
	},
	"webpack/sharing/consume/default/app/shared/reducers/locale/app/shared/reducers/locale": {
		getter: () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react-jhipster_react-jhipster"), __webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("webpack_sharing_consume_default_dayjs_dayjs-webpack_sharing_consume_default_tslib_tslib"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("src_main_webapp_app_shared_reducers_locale_ts")]).then(() => (() => (__webpack_require__(/*! app/shared/reducers/locale */ "./src/main/webapp/app/shared/reducers/locale.ts"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "app/shared/reducers/locale",
	},
	"webpack/sharing/consume/default/reactstrap/reactstrap": {
		getter: () => (Promise.all([__webpack_require__.e("vendors-node_modules_prop-types_index_js"), __webpack_require__.e("vendors-node_modules_reactstrap_esm_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("webpack_sharing_consume_default_react-transition-group_react-transition-group")]).then(() => (() => (__webpack_require__(/*! reactstrap */ "./node_modules/reactstrap/esm/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "9.2.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "reactstrap",
	},
	"webpack/sharing/consume/default/react-hook-form/react-hook-form": {
		getter: () => (__webpack_require__.e("vendors-node_modules_react-hook-form_dist_index_esm_mjs").then(() => (() => (__webpack_require__(/*! react-hook-form */ "./node_modules/react-hook-form/dist/index.esm.mjs"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "7.53.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-hook-form",
	},
	"webpack/sharing/consume/default/react-dom/react-dom": {
		getter: () => (__webpack_require__.e("vendors-node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	"webpack/sharing/consume/default/react-router/react-router": {
		getter: () => (__webpack_require__.e("vendors-node_modules_react-router_dist_index_js").then(() => (() => (__webpack_require__(/*! react-router */ "./node_modules/react-router/dist/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.27.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	},
	"webpack/sharing/consume/default/react-transition-group/react-transition-group": {
		getter: () => (__webpack_require__.e("vendors-node_modules_react-transition-group_esm_index_js").then(() => (() => (__webpack_require__(/*! react-transition-group */ "./node_modules/react-transition-group/esm/index.js"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.4.5",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-transition-group",
	},
	"webpack/sharing/consume/default/app/config/store/app/config/store": {
		getter: () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react-jhipster_react-jhipster"), __webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("webpack_sharing_consume_default_axios_axios"), __webpack_require__.e("webpack_sharing_consume_default_react-redux_react-redux"), __webpack_require__.e("webpack_sharing_consume_default_app_shared_reducers_reducer_utils_app_shared_reducers_reducer_utils"), __webpack_require__.e("webpack_sharing_consume_default_react-toastify_react-toastify"), __webpack_require__.e("webpack_sharing_consume_default_react-redux-loading-bar_react-redux-loading-bar"), __webpack_require__.e("webpack_sharing_consume_default_app_shared_reducers_app_shared_reducers"), __webpack_require__.e("src_main_webapp_app_config_store_ts")]).then(() => (() => (__webpack_require__(/*! app/config/store */ "./src/main/webapp/app/config/store.ts"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "app/config/store",
	},
	"webpack/sharing/consume/default/app/shared/error/error-boundary-routes/app/shared/error/error-boundary-routes": {
		getter: () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react-jhipster_react-jhipster"), __webpack_require__.e("webpack_sharing_consume_default_react-router-dom_react-router-dom"), __webpack_require__.e("src_main_webapp_app_shared_error_error-boundary-routes_tsx")]).then(() => (() => (__webpack_require__(/*! app/shared/error/error-boundary-routes */ "./src/main/webapp/app/shared/error/error-boundary-routes.tsx"))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "app/shared/error/error-boundary-routes",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_react_react": [
		"webpack/sharing/consume/default/react/react"
	],
	"webpack_sharing_consume_default_fortawesome_fontawesome-svg-core_fortawesome_fontawesome-svg-core": [
		"webpack/sharing/consume/default/@fortawesome/fontawesome-svg-core/@fortawesome/fontawesome-svg-core"
	],
	"webpack_sharing_consume_default_redux_redux": [
		"webpack/sharing/consume/default/redux/redux"
	],
	"webpack_sharing_consume_default_react-jhipster_react-jhipster": [
		"webpack/sharing/consume/default/react-jhipster/react-jhipster"
	],
	"webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit": [
		"webpack/sharing/consume/default/@reduxjs/toolkit/@reduxjs/toolkit"
	],
	"webpack_sharing_consume_default_axios_axios": [
		"webpack/sharing/consume/default/axios/axios"
	],
	"webpack_sharing_consume_default_react-redux_react-redux": [
		"webpack/sharing/consume/default/react-redux/react-redux"
	],
	"webpack_sharing_consume_default_app_shared_reducers_reducer_utils_app_shared_reducers_reducer_utils": [
		"webpack/sharing/consume/default/app/shared/reducers/reducer.utils/app/shared/reducers/reducer.utils"
	],
	"webpack_sharing_consume_default_react-toastify_react-toastify": [
		"webpack/sharing/consume/default/react-toastify/react-toastify"
	],
	"webpack_sharing_consume_default_react-redux-loading-bar_react-redux-loading-bar": [
		"webpack/sharing/consume/default/react-redux-loading-bar/react-redux-loading-bar"
	],
	"webpack_sharing_consume_default_app_shared_reducers_app_shared_reducers": [
		"webpack/sharing/consume/default/app/shared/reducers/app/shared/reducers"
	],
	"webpack_sharing_consume_default_react-router-dom_react-router-dom": [
		"webpack/sharing/consume/default/react-router-dom/react-router-dom"
	],
	"webpack_sharing_consume_default_dayjs_dayjs-webpack_sharing_consume_default_tslib_tslib": [
		"webpack/sharing/consume/default/tslib/tslib",
		"webpack/sharing/consume/default/dayjs/dayjs"
	],
	"webpack_sharing_consume_default_app_shared_reducers_locale_app_shared_reducers_locale": [
		"webpack/sharing/consume/default/app/shared/reducers/locale/app/shared/reducers/locale"
	],
	"webpack_sharing_consume_default_react-hook-form_react-hook-form-webpack_sharing_consume_defau-c3c16d": [
		"webpack/sharing/consume/default/reactstrap/reactstrap",
		"webpack/sharing/consume/default/react-hook-form/react-hook-form"
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		"webpack/sharing/consume/default/react-dom/react-dom"
	],
	"webpack_sharing_consume_default_react-router_react-router": [
		"webpack/sharing/consume/default/react-router/react-router"
	],
	"webpack_sharing_consume_default_react-transition-group_react-transition-group": [
		"webpack/sharing/consume/default/react-transition-group/react-transition-group"
	],
	"webpack_sharing_consume_default_app_config_store_app_config_store": [
		"webpack/sharing/consume/default/app/config/store/app/config/store"
	],
	"webpack_sharing_consume_default_app_shared_error_error-boundary-routes_app_shared_error_error-71e9c6": [
		"webpack/sharing/consume/default/app/shared/error/error-boundary-routes/app/shared/error/error-boundary-routes"
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}